import { ProductParametersKey } from '../storage/agreements/agreements.model';
import { SimulationParameter } from '../storage/product/product.model';

const findProductParameter = (
  data: SimulationParameter[],
  key: ProductParametersKey
) => data?.find((item: SimulationParameter) => item.key === key);

export default findProductParameter;
